<template>
    <wallet-v2 v-if="shouldShowWalletV2" />
    <wallet-v1 v-else />
</template>

<script>
// 3rd party libs
import {
    mapGetters,
} from 'vuex';

// Components
import walletV1 from './wallet-v1.vue';
import walletV2 from './wallet-v2.vue';


export default {
    name: 'wallet',
    components: {
        walletV1,
        walletV2,
    },

    computed: {
        ...mapGetters('wallet', ['shouldShowWalletV2']),
    },
};
</script>